import styled, { css } from 'styled-components';
import { shade } from 'polished';

interface PostItemProps {
  isDragging: boolean;
}

export const Container = styled.div`
  width: 100%;
  max-width: 900px;
  min-height: 85dvh;
  margin: 40px auto;
  padding: 20px;
`;

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  /* margin-top: 60px; */

  h1 {
    color: ${(props) => props.theme.colors.text};
  }

  button {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 24px;
    background: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.white};
    border: 0;
    border-radius: 8px;
    font-weight: 500;
    transition: background-color 0.2s;

    &:hover {
      background: ${(props) => props.theme.colors.primary_dark};
    }
  }
`;

export const PostList = styled.div`
  background: ${(props) => props.theme.colors.card_background};
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
`;

export const PostItem = styled.div<PostItemProps>`
  display: flex;
  align-items: center;
  padding: 16px;
  border-radius: 4px;
  border: 1px solid #eee;
  background: #fff;
  transition: box-shadow 0.2s;

  & + div {
    margin-top: 10px;
  }

  ${(props) =>
    props.isDragging &&
    css`
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
      background: #f8f9fa;
    `}

  a {
    flex: 1;
    margin: 0 16px;
    color: ${(props) => props.theme.colors.primary};
    text-decoration: none;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:hover {
      text-decoration: underline;
    }
  }

  button {
    background: transparent;
    border: 0;
    color: ${(props) => props.theme.colors.error};
    transition: color 0.2s;

    &:hover {
      color: ${(props) => shade(0.2, props.theme.colors.error)};
    }
  }
`;

export const DragHandle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  color: #ccc;
`;
